import { KeyframeNode2D } from "./KeyframeNode2D";
import { Keyframe2D } from "./KeyFrame2D";
import { Animation2DEvent } from "./Animation2DEvent";
import { PathPoint } from "../tween/PathPoint";
import { CurvePath } from "../tween/CurvePath";
export class AnimationClip2DParse01 {
    static READ_DATA() {
        this._DATA.offset = this._reader.readUint32();
        this._DATA.size = this._reader.readUint32();
    }
    static READ_BLOCK() {
        var count = this._BLOCK.count = this._reader.readUint16();
        var blockStarts = this._BLOCK.blockStarts = [];
        var blockLengths = this._BLOCK.blockLengths = [];
        for (var i = 0; i < count; i++) {
            blockStarts.push(this._reader.readUint32());
            blockLengths.push(this._reader.readUint32());
        }
    }
    static READ_STRINGS() {
        var offset = this._reader.readUint32();
        var count = this._reader.readUint16();
        var prePos = this._reader.pos;
        this._reader.pos = offset + this._DATA.offset;
        for (var i = 0; i < count; i++)
            this._strings[i] = this._reader.readUTFString();
        this._reader.pos = prePos;
    }
    static parse(clip, reader, version) {
        this._clip = clip;
        this._reader = reader;
        this._version = version;
        this.READ_DATA();
        this.READ_BLOCK();
        this.READ_STRINGS();
        for (var i = 0, n = this._BLOCK.count; i < n; i++) {
            var index = reader.readUint16();
            var blockName = this._strings[index];
            var fn = this["READ_" + blockName];
            if (!fn) {
                throw new Error("model file err,no this function:" + index + " " + blockName);
            }
            else
                fn.call(this);
        }
        this._version = null;
        this._reader = null;
        this._clip = null;
        this._strings.length = 0;
    }
    static timeToFrame(second, fps) {
        return Math.round(second * fps);
    }
    static createPathPoints(arr) {
        const result = [];
        for (var i = 0, len = arr.length; i < len; i++) {
            const data = arr[i];
            const point = new PathPoint();
            point.pos.x = data.pos.x;
            point.pos.y = data.pos.y;
            point.pos.z = data.pos.z;
            point.c1.x = data.c1.x;
            point.c1.y = data.c1.y;
            point.c1.z = data.c1.z;
            point.c2.x = data.c2.x;
            point.c2.y = data.c2.y;
            point.c2.z = data.c2.z;
            point.curve = data.curve;
            point.rotationType = data.rotationType;
            result.push(point);
        }
        return result;
    }
    static READ_ANIMATIONS2D() {
        var i, j;
        var reader = this._reader;
        var clip = this._clip;
        var node;
        var numList = [];
        var numCount = reader.readUint16();
        numList.length = numCount;
        for (i = 0; i < numCount; i++) {
            numList[i] = reader.readFloat32();
        }
        var clipDur = clip._duration = numList[reader.readInt16()];
        clip.islooping = !!reader.readByte();
        clip._frameRate = reader.readInt16();
        var nodeCount = reader.readInt16();
        var nodes = clip._nodes;
        nodes.count = nodeCount;
        var nodesMap = clip._nodesMap = {};
        var nodesDic = clip._nodesDic = {};
        for (i = 0; i < nodeCount; i++) {
            node = new KeyframeNode2D();
            nodes.setNodeByIndex(i, node);
            node._indexInList = i;
            var pathLength = reader.readUint16();
            node._setOwnerPathCount(pathLength);
            for (j = 0; j < pathLength; j++) {
                node._setOwnerPathByIndex(j, this._strings[reader.readUint16()]);
            }
            var nodePath = node._joinOwnerPath("/");
            var mapArray = nodesMap[nodePath];
            (mapArray) || (nodesMap[nodePath] = mapArray = []);
            mapArray.push(node);
            var propertyLength = reader.readUint16();
            node._setPropertyCount(propertyLength);
            for (j = 0; j < propertyLength; j++) {
                node._setPropertyByIndex(j, this._strings[reader.readUint16()]);
            }
            var fullPath = nodePath + "." + node._joinProperty(".");
            nodesDic[fullPath] = node;
            node.fullPath = fullPath;
            node.nodePath = nodePath;
            var keyframeCount = reader.readUint16();
            for (j = 0; j < keyframeCount; j++) {
                var k = new Keyframe2D();
                k.time = numList[reader.readUint16()];
                k.data = { f: this.timeToFrame(k.time, clip._frameRate), val: 0 };
                if (1 == reader.readByte()) {
                    k.data.tweenType = this._strings[reader.readUint16()];
                }
                if (1 == reader.readByte()) {
                    k.data.tweenInfo = {};
                    k.data.tweenInfo.inTangent = numList[reader.readUint16()];
                    k.data.tweenInfo.outTangent = numList[reader.readUint16()];
                    if (1 == reader.readByte()) {
                        k.data.tweenInfo.inWeight = numList[reader.readUint16()];
                    }
                    if (1 == reader.readByte()) {
                        k.data.tweenInfo.outWeight = numList[reader.readUint16()];
                    }
                }
                var num = reader.readByte();
                if (0 == num) {
                    k.data.val = numList[reader.readUint16()];
                }
                else if (1 == num) {
                    k.data.val = this._strings[reader.readUint16()];
                }
                else if (2 == num) {
                    k.data.val = !!reader.readByte();
                }
                else if (3 == num) {
                    const jsonData = JSON.parse(reader.readUTFString());
                    if (Array.isArray(jsonData)) {
                        const curvePath = new CurvePath();
                        k.data.val = curvePath;
                        curvePath._$data = jsonData;
                        curvePath.create(...this.createPathPoints(jsonData));
                    }
                    else {
                        k.data.val = jsonData;
                    }
                }
                if (1 == reader.readByte()) {
                    try {
                        k.data.extend = JSON.parse(this._strings[reader.readUint16()]);
                    }
                    catch (err) { }
                }
                node._keyFrames.push(k);
            }
        }
        var eventCount = reader.readUint16();
        for (i = 0; i < eventCount; i++) {
            var event = new Animation2DEvent();
            event.time = numList[reader.readUint16()];
            event.eventName = this._strings[reader.readUint16()];
            var params = [];
            var paramCount = reader.readUint16();
            (paramCount > 0) && (event.params = params = []);
            for (j = 0; j < paramCount; j++) {
                var eventType = reader.readByte();
                switch (eventType) {
                    case 0:
                        params.push(!!reader.readByte());
                        break;
                    case 1:
                        params.push(reader.readInt32());
                        break;
                    case 2:
                        params.push(numList[reader.readUint16()]);
                        break;
                    case 3:
                        params.push(this._strings[reader.readUint16()]);
                        break;
                    default:
                        throw new Error("unknown type.");
                }
            }
            clip.addEvent(event);
        }
    }
}
AnimationClip2DParse01._strings = [];
AnimationClip2DParse01._DATA = { offset: 0, size: 0 };
AnimationClip2DParse01._BLOCK = { count: 0 };
